// LIFF ID.
// アプリとLINEの連携（prod） : 1656105485-aPg2dM02
// アプリとLINEの連携（stage） : 1656105485-uInJSx58
export const LIFF_ID = "1656105485-aPg2dM02" // e.g. "1657244793-4K63WeeV"
// Universal Link URL.
export const UNIVERSAL_LINK_URL = "https://m.e-welcia.com/app/applink/lineuser.html";
